window.SkillsAPI = new function() {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.getUserSkills = function() {

        var deferred = $q.defer();

        _protected.request("user_skills", "GET")
            .then(function(res){
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    }

    self.saveUserSkills = function(skills) {
        var deferred = $q.defer();

        var skillsIds = [];

        skills.forEach(function(skill){
            skillsIds.push(skill.id);
        });

        _protected.request("user_skills", "PUT", { skills: skillsIds })
            .then(function(res){
                deferred.resolve(res);
            });

        return deferred.promise;
    }
}